import styles from './SocialMediaLink.css'

class SocialMediaLink extends React.Component {
  render () {
    let {website, twitter, facebook, instagram} = this.props
    return (<div className={styles.wrapper}>
      <div className={styles.header}>
        LINKS
      </div>
      <ul>
        <li>
          <span className={`fa-stack ${styles['link-icon-wrapper']}`}>
            <i className='fa fa-circle fa-stack-2x' />
            <i className='fa fa-link fa-stack-1x fa-inverse' />
          </span>

          <span>{website}</span>
        </li>
        <li>
          <span className={`fa-stack ${styles['twitter-icon-wrapper']}`}>
            <i className='fa fa-circle fa-stack-2x' />
            <i className='fa fa-twitter fa-stack-1x fa-inverse' />
          </span>

          <span>{twitter}</span>
        </li>
        <li>
          <span className={`fa-stack ${styles['facebook-icon-wrapper']}`}>
            <i className='fa fa-circle fa-stack-2x' />
            <i className='fa fa-facebook fa-stack-1x fa-inverse' />
          </span>
          <span>{facebook}</span>
        </li>
        <li>
          <span className={`fa-stack ${styles['instagram-icon-wrapper']}`}>
            <i className='fa fa-circle fa-stack-2x' />
            <i className='fa fa-instagram fa-stack-1x fa-inverse' />
          </span>
          <span>{instagram}</span>
        </li>
      </ul>
    </div>)
  }
}

SocialMediaLink.propTypes = {
  website: React.PropTypes.string,
  twitter: React.PropTypes.string,
  facebook: React.PropTypes.string,
  instagram: React.PropTypes.string
}

export default SocialMediaLink



// WEBPACK FOOTER //
// ./app/components/receipt/commons/SocialMediaLink/SocialMediaLink.js